/// <amd-module name="Feed/CreateFeed/Redux/CreateFeed/CreateFeedModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { getTfsPageDataModule } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataModule";

import { ICreateFeedOwnState } from "./CreateFeedContracts";
import { createFeedReducer } from "./CreateFeedReducers";
import rootSaga from "./CreateFeedSaga";

const _createFeedModule: ISagaModule<ICreateFeedOwnState> = {
    id: "feed-create-feed",
    reducerMap: {
        createFeedState: createFeedReducer
    },
    sagas: [rootSaga]
};

export const CreateFeedModule = [getTfsPageDataModule(), _createFeedModule];
